/* eslint-disable */
import React, { useContext, useEffect, useLayoutEffect, useRef } from "react";
import { Outlet, useLocation, useSearchParams } from "react-router-dom";
import { BottomNavMenu } from "components/BottomNavMenu";
import { SideNavMenu } from "components/SideNavMenu";
// import { Layout } from "antd";
import { CommonContext } from "contexts/CommonContext";
import { pushToDataLayer } from "core/utils/utils.helper";
import useAuth from "hooks/useAuth";
import { handleUtmFunctions } from "helpers/common.helper";
import { utmFunctionsType } from "models/general";
import styles from "./MenuWithOutHeaderLayout.module.scss";
import Layout from "antd/es/layout";

export const MenuWithOutHeaderLayout: React.FC = () => {
  const { isTablet } = useContext(CommonContext);
  const location = useLocation();
  const contentRef = useRef<HTMLDivElement>(null);
  const auth: any = useAuth(); // Access authentication context
  const isLoggedIn: boolean = auth && auth.isAuthenticated; // Check if user is authenticated
  let [searchParams] = useSearchParams(); // search url parameter

  //store utm_source for product refferers
  useEffect(() => {
    searchParams && handleUtmFunctions(searchParams, utmFunctionsType.REFERRER);
  }, [searchParams]);

  useEffect(() => {
    // Push the event to the dataLayer on every route change
    pushToDataLayer({
      event: "PAGE_VIEW",
      user_status: isLoggedIn,
      event_type: "pageview",
    });
  }, [location]);

  useLayoutEffect(() => {
    // Scroll the div with the contentRef to the top when the route changes
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [location, contentRef]); // Trigger this effect whenever the pathname changes
  return (
    <div className={styles.app_container_no_header}>
      <div
        className={`${styles.outlet_container} ${styles.container_fluid} ${isTablet && styles.outlet_container__device_overflow}`}
      >
        {!isTablet ? (
          <Layout className={styles.desktop_container}>
            <SideNavMenu />
            <Layout.Content>
              <div className={styles.content_wrapper} ref={contentRef}>
                <Outlet />
              </div>
            </Layout.Content>
          </Layout>
        ) : (
          <div ref={contentRef} className={styles.mobile_container}>
            <Outlet />
          </div>
        )}
      </div>
      {isTablet ? <BottomNavMenu /> : ""}
    </div>
  );
};
